import ProductPageContent from "components/ProductPageContent";
import { PRODUCT_PAGES } from "data/productPages";

function FlexibleStoneVeneerPage() {
  return <ProductPageContent data={PRODUCT_PAGES["flexible-stone-veneer"]} />;
}

export default FlexibleStoneVeneerPage;
